import React from "react";

const FAQBox = ({ phone, phone_text, phoneOnly }) => {

    const phone_number = phone ? "tel:" + phone : "tel:+18884281149"
    const written_phone = phone_text ? phone_text : "+1 (888)-428-1149"
    return (
        <div className="schedule-faq">
            <div className="schedule-faq-box">
                <h4>Have questions? {phoneOnly ? null : <a href="../faq" target="_blank" rel="noopener noreferrer">Explore our FAQ</a>}</h4>
                <p>Contact our team at <a href={phone_number}>{written_phone}</a> via text or chat with us.</p>
            </div>
        </div>
    )
}

export default FAQBox